/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_CreateInputs */

const en_dialog_create = /** @type {(inputs: Dialog_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const es_dialog_create = /** @type {(inputs: Dialog_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Dialog_CreateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_create = /** @type {((inputs?: Dialog_CreateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_CreateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_create(inputs)
	return en_dialog_create(inputs)
});